// {
//   name: '上游合作方名称',
//   prop: 'upPartnerCode',
//   type: 'searchTableSpec',
//   searchType: 'partnerNoFilter',
//   currentValue: ctx.baseInfoData.upPartnerName,
//   changeMethod: 'changeMethod',
//   isMultiple: true,
//   extraData: {
//     // partnerTypes: 'HZHB01',
//     companyCode: ctx.userInfo.companyCode,
//     departmentCode: ctx.userInfo.departmentCode,
//   },
// },
// {
//   name: '上游合作方企业性质',
//   prop: 'upPartnerNature',
//   type: 'ajaxSelect',
//   apiUrl: BASE_API.DIC_CREDIT_API,
//   apiData: { dictType: 'enterprise_type' },
//   currentValue: ctx.baseInfoData.upPartnerNature,
//   // fixme  根据合同方自动带出
// },
// {
//   name: '上游合作方法人',
//   prop: 'upPartnerLegalPerson',
//   type: 'input',
//   // fixme    根据合同方自动带出
// },
// {
//   name: '上游合作方联系人',
//   prop: 'upPartnerContactPerson',
//   type: 'input',
//   // fixme    根据合同方自动带出
// },
// {
//   name: '上游合作方联系电话',
//   prop: 'upPartnerContactPhone',
//   type: 'inputNumber',
//   precision: 0,
//   // fixme    根据合同方自动带出  可修改
// },
// {
//   name: '上游合作方联系邮箱',
//   prop: 'upPartnerContactEmail',
//   type: 'input',
//   // fixme    根据合同方自动带出  可修改
// },
// {
//   name: '上游合作方付款方式',
//   prop: 'upPartnerPayMethod',
//   type: 'select',
//   options: ctx.payMethodList,
//   changeMethod: 'changeMethod',
//   multiple: true,
//   // fixme
// },
// {
//   name: '上游合作方对账规则',
//   prop: 'upPartnerReconciliationRules',
//   type: 'ajaxSelect',
//   apiUrl: BASE_API.DIC_CREDIT_API,
//   apiData: { dictType: 'INTERMODALITY-RECONCILIATION-RULES' },
// },
// {
//   name: '下游合作方名称',
//   prop: 'downPartnerCode',
//   type: 'searchTableSpec',
//   searchType: 'partnerNoFilter',
//   currentValue: ctx.baseInfoData.downPartnerName,
//   changeMethod: 'changeMethod',
//   extraData: {
//     companyCode: ctx.userInfo.companyCode,
//     departmentCode: ctx.userInfo.departmentCode,
//   },
//   isMultiple: true,
// },
// {
//   name: '下游合作方企业性质',
//   prop: 'downPartnerNature',
//   type: 'ajaxSelect',
//   apiUrl: BASE_API.DIC_CREDIT_API,
//   apiData: { dictType: 'enterprise_type' },
//   currentValue: ctx.baseInfoData.downPartnerNature,
//   // fixme    根据合同方自动带出
// },
// {
//   name: '下游合作方法人',
//   prop: 'downPartnerLegalPerson',
//   type: 'input',
//   // fixme    根据合同方自动带出
// },
// {
//   name: '下游合作联系人',
//   prop: 'downPartnerContactPerson',
//   type: 'input',
//   // fixme    根据合同方自动带出  可修改
// },
// {
//   name: '下游合作方联系电话',
//   prop: 'downPartnerContactPhone',
//   type: 'inputNumber',
//   precision: 0,
//   // fixme    根据合同方自动带出  可修改
// },
// {
//   name: '下游合作方联系邮箱',
//   prop: 'downPartnerContactEmail',
//   type: 'input',
//   // fixme    根据合同方自动带出  可修改
// },
// {
//   name: '下游合作方结算方式',
//   prop: 'downPartnerPayMethod',
//   type: 'select',
//   options: ctx.payMethodList,
//   changeMethod: 'changeMethod',
//   multiple: true,
//   // fixme
// },
// {
//   name: '下游合作方对账规则',
//   prop: 'downPartnerReconciliationRules',
//   type: 'ajaxSelect',
//   apiUrl: BASE_API.DIC_CREDIT_API,
//   apiData: { dictType: 'INTERMODALITY-RECONCILIATION-RULES' },
//   // fixme
// },

export const upPartnerColumns = [
  {
    field: 'upPartnerName',
    title: '上游合作方名称',
    width: '180',
    editRender: {
      name: 'upPartnerName',
    },
  },
  {
    field: 'upPartnerNature',
    title: '上游合作方企业性质',
    width: '180',
    editRender: {
      name: 'select',
      dict: 'enterprise_type',
    },
  },
  {
    field: 'upPartnerLegalPerson',
    title: '上游合作方法人',
    width: '180',
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'upPartnerContactPerson',
    title: '上游合作方联系人',
    width: '180',
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'upPartnerContactPhone',
    title: '上游合作方联系电话',
    width: '180',
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'upPartnerContactEmail',
    title: '上游合作方联系邮箱',
    width: '180',
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'upPartnerPayMethod',
    title: '上游合作方付款方式',
    width: '180',
    editRender: {
      name: 'select',
      dict: 'mto_payment_method',
      multiple: true,
    },
  },
  {
    field: 'upPartnerReconciliationRules',
    title: '上游合作方对账规则',
    width: '180',
    editRender: {
      name: 'select',
      dict: 'INTERMODALITY-RECONCILIATION-RULES',
    },
  },
];

export const downPartnerColumns = [
  {
    field: 'downPartnerName',
    title: '下游合作方名称',
    width: '180',
    editRender: {
      name: 'downPartnerName',
    },
  },
  {
    field: 'downPartnerNature',
    title: '下游合作方企业性质',
    width: '180',
    editRender: {
      name: 'select',
      dict: 'enterprise_type',
    },
  },
  {
    field: 'downPartnerLegalPerson',
    title: '下游合作方法人',
    width: '180',
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'downPartnerContactPerson',
    title: '下游合作方联系人',
    width: '180',
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'downPartnerContactPhone',
    title: '下游合作方联系电话',
    width: '180',
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'downPartnerContactEmail',
    title: '下游合作方联系邮箱',
    width: '180',
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'downPartnerPayMethod',
    title: '下游合作方付款方式',
    width: '180',
    editRender: {
      name: 'select',
      dict: 'mto_payment_method',
      multiple: true,
    },
  },
  {
    field: 'downPartnerReconciliationRules',
    title: '下游合作方对账规则',
    width: '180',
    editRender: {
      name: 'select',
      dict: 'INTERMODALITY-RECONCILIATION-RULES',
    },
  },
];
